import React from 'react';
import { auth } from '../firebase';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';

function SignIn() {
  const signInWithGoogle = async () => {
    const provider = new GoogleAuthProvider();
    try {
      await signInWithPopup(auth, provider);
    } catch (err) {
      if (err.code !== 'auth/popup-closed-by-user') {
        console.error('Sign-in failed:', err);
      }
    }
  };

  return (
    <div className="signin-container">
      <div className="signin-card">
        <div className="signin-logo-badge">
          <img src={process.env.PUBLIC_URL + '/logo192.png'} alt="RhytoLeaf logo" className="signin-logo-img" />
        </div>
        <h1 className="signin-title">RhytoLeaf</h1>
        <p className="signin-sub">Superchat</p>
        <button className="signin-google-btn" onClick={signInWithGoogle}>
          <span className="google-icon">G</span>
          Sign in with Google
        </button>
        <p className="signin-guidelines">
          Community guidelines apply. Violations may result in a permanent ban.
        </p>
      </div>
    </div>
  );
}

export default SignIn;
